import { ref } from 'vue';
import { defineStore } from 'pinia';
import * as request from '@/request/common.js';
import router from '@/router';
export const usePermissionStore = defineStore('usePermission', () => {
    // 用户信息
    const userInfo = ref({
    });
    // 公共配置
    const configInfo = ref({

    })

    // 获取用户信息
    const getUserInfoFun = async () => {
        if (!Object.keys(userInfo.value).length) {
            try {
                const res = await request.post({ url: 'getUserInfo', costom: { hideModal: true } });
                res.data.user_id = res.data.id
                userInfo.value = res.data || {};
                return true;
            } catch (err) {
                return false;
            }
        } else {
            return true;
        }
    };
    const getCommonConfig = async () => {
        if (!Object.keys(configInfo.value).length) {
            try {
                const res = await request.get({ url: 'getCommonConfig',data: { id: 1 }, costom: { hideModal: true } });
                configInfo.value = res.data || {};
                return true;
            } catch (err) {
                return false;
            }
        } else {
            return true;
        }
    }
    

    return {
        userInfo,
        configInfo,
        getUserInfoFun,
        getCommonConfig
    };
});
